import { setTheme } from "./Components/topbars/topBarFuncs";
import { SiteConfig, UrlConfig } from "./siteConfigTypes";
import { SolicitorNavigate } from "./SideDrawer/sidedrawer";
import { isDarkTheme } from "./Components/topbars/topBarFuncs";
/* eslint-disable @typescript-eslint/no-this-alias */
// TODO: should not have root path, instead it should be based on the referer url
// for any popup related to main page, if it is relative, it will be fixed based on the main page url
// if it is initialized in the react shell, caller should know what is the full url from root
// if react shell want to any functions based  on url form current open main page
// it is related to current main page.
// However, new coding should not depond on main page unless it is basicly extension of current main page
// like left side nav menu which only related to file edit page
// main page can be anything, may be a /DR/inbox.asp
// main page link normally is point to dr, if need to be link to RPW, DR should know the full page 
// just as existing IE system
type frameType = 'popup' | 'modal' | 'modeless' | 'iframe';
//universal string need to be ignored
var urlMatchIgnore = /&(compat|savedID)=\d+/gi;
// function defaultRestartFunction(url, _oldurl, dom) {
//     let content: any = dom
//     resetLivedataRoot(dom);
//     if (content.onld) {
//         content.onld(url);
//     }
//     return true
// }

// function resetLivedataRoot(dom: any) {
//     const state = store.getState();
//     let livedataRoot = state?.currentNavigation?.livedataRootContainer?.dataRoot;
//     if (livedataRoot) {
//         dom.xmlbaseNode = livedataRoot;
//         dom.livedataSrc = livedataRoot.ownerDocument;
//         dom.livedataRoot = livedataRoot;
//     }
//     if (dom.onload) {
//         dom.onload();
//     }
// }

let siteConfig = (window as any).compatURLConf;

var FrameCache: Array<Frame> = [];
class Frame {
    //  isMain: boolean;
    closed = false; // start is always open
    type: frameType = 'iframe';
    iframe: HTMLIFrameElement;
    urlConfig: UrlConfig;
    // from page config
    //  customRestartCode: Function;
    // matchPatten: RegExp;
    parentDialog?: Dialog;
    currentPopup?: Dialog;
    url: string;
    static GetFrame(url: string, parent: HTMLElement | 'dialog'): Frame | undefined {
        var ret = FrameCache.find((frame: Frame, _index: number) => {
            if ((typeof parent === 'string' && parent === 'dialog' && frame.parentDialog)
                || (frame.iframe.parentElement === parent))
                return frame.isMatch(url);
            else
                return false;
        });
        return ret;
    }
    static RemoveFrame(f: Frame) {
        if (f.closed) { // only closed allow, because it is only called from .close()
            var index = FrameCache.indexOf(f);
            if (index >= 0) {
                FrameCache.splice(index, 1);
                f.iframe.parentElement.removeChild(f.iframe);
            }
            else {
                console.assert(false, 'cannot find deleted frame in cache');
            }

        } else {
            throw (new Error('cannot close a open frame'));
        }
    }
    static GetUrlConfig(url: string): UrlConfig {
        // default is full url match
        var ret: UrlConfig = { type: 'fullurl', name: url, needCompatHost: true, needRestart: true };
        if (siteConfig && siteConfig.urlConfig) {
            for (const conf of siteConfig.urlConfig) {
                if (Frame.matchUrl(url, conf)) {
                    Object.assign(ret, conf);
                    if (ret.needSeperateFrame) {
                        ret.pattern = undefined; // remove pattern matching
                        ret.type = 'fullurl';
                    }
                    break;
                }
            }
        }
        return ret;
    }
    constructor(url: string, parent: HTMLElement, winObjs: any) {
        // parent holder cannot be changed once created, because iframe will onload
        // when move to another parent, it is like remove and create again
        // insert to a parent will trigger reload of page, no reload
        // we assume , GetFrame is called first to check for cache, only create 
        // when needed.
        this.url = url;
        this.iframe = parent.ownerDocument.createElement('iframe');
        this.urlConfig = Frame.GetUrlConfig(url);
        // should have some styles?? like 100%, scroll bar etc.
        this.iframe.className = 'clsCompatHost';
        let iframeSrc = url;
        if (this.urlConfig.needCompatHost) {
            if (url.indexOf('compathost.html#') === -1)
                var fid = Math.floor(Math.random() * 10000);
            if (url.search(/^(\w+\.asp)/) != -1)   //look for sth like lfpopup.asp
                url = url.replace(/^(\w+\.asp)/, `compathost.html?_a=${fid}#$1`);
            else if (url.indexOf('../') == 0 && url.search(/(\/\w+\.asp)/) != -1) {  //look for sth like ../../wills/lfpopup.asp
                url = url.replace(/(\/\w+\.asp)/, `/compathost.html?_a=${fid}#$1`);
                url = url.replace(`/compathost.html?_a=${fid}#/`, `/compathost.html?_a=${fid}#`);
            }
            iframeSrc = url;
            if (url.indexOf('NoHeader=1') === -1) {
                if (url.indexOf('?') === -1) {
                    iframeSrc += '?';
                } else {
                    iframeSrc += '&';
                }
                iframeSrc += 'NoHeader=1';
            }
        }
        this.iframe.src = iframeSrc;
        // have to set srcv first before add to dom
        parent.appendChild(this.iframe);
        var contentWindow = this.iframe.contentWindow;
        if (contentWindow) {
            if (isDarkTheme()) {
                this.iframe.contentDocument.body.classList.add("dark");
            }
            contentWindow['topWindowShowModalDialog'] = (url: string, arg: any, opt: string) => {
                return showModalDialog(url, arg, opt, this);
            }
            contentWindow['topWindowShowModelessDialog'] = (url: string, arg: any, opt: string) => {
                return showModelessDialog(url, arg, opt, this);
            }
            contentWindow['topWindowIsShell'] = true;
            // standard host servicesObj
            for (let p in mainHostServiceObjs)
                contentWindow[p] = mainHostServiceObjs[p];
            if (winObjs) {
                const objKeys = Object.keys(winObjs)
                for (let p = 0; p < objKeys.length; p++) {
                    contentWindow[objKeys[p]] = winObjs[objKeys[p]];
                }
            }
            // insert to cache
            FrameCache.push(this);
            this.iframe.contentWindow.addEventListener('loaderjsFinished', setTheme);
            this.iframe.contentWindow.onmousedown = function () {
                try {
                    window.document.getElementById("lddIFrame").click()
                } catch (e) {  }
            }
        }
        // do not set src yet. 
        console.assert(contentWindow === this.iframe.contentWindow);

    }
    static matchUrl(url, conf: UrlConfig): boolean {
        var ret = false;
        url = url.replace(/&compat=\d+/g, '');
        if (conf.pattern)
            ret = !!url.match(conf.pattern);
        else {
            switch (conf.type) {
                case 'fullurl':
                    ret = (url === conf.name.replace(urlMatchIgnore, ''));
                    break;
                case 'asp':
                    ret = (url.indexOf(conf.name + '.asp') >= 0);
                    break;
                case 'html':
                    ret = (url.indexOf(conf.name + '.html') >= 0);
                    break;
                case 'formasp':
                    ret = (url.indexOf('formasp=' + conf.name) >= 0);
                    break;
                case 'formxml':
                    ret = (url.indexOf('formxml=' + conf.name) >= 0);
                    break;
                default:
                    break;
            }
        }
        return ret;
    }
    isMatch(url: string) {
        // advanced 
        url = url.replace(urlMatchIgnore, '');
        if (this.urlConfig && !this.urlConfig.needSeperateFrame)
            return Frame.matchUrl(url, this.urlConfig);
        else
            return this.url.replace(urlMatchIgnore, '') === url;
    }
    showFrame() {
        this.iframe.style.display = '';
    }
    hideFrame() {
        this.iframe.style.display = 'none';
    }
    closePopup(): boolean {
        if (this.currentPopup) { // close current popup first
            if (!this.currentPopup.close())
                return false;
        }
        this.currentPopup = undefined;
        this.showFrame();
        return true;
    }
    // close means close by user, we can keep it around but will need to restart when show again
    close(bAutoRemove = true): boolean {
        if (this.closed !== true) {
            if (!this.closePopup())
                return false;
            var unloadEvent = new Event('beforeunload', { bubbles: false, cancelable: true });
            var unloadStopped = false;
            // chrome need to call preventDefault to stop, but it will ask. we don't have to
            // also returnValue can be set (anything other then undefined will trig ask by chrome, so make sure remove it
            unloadEvent.preventDefault = function () { unloadStopped = true; }
            // setup windows event obj
            //iframe.contentWindow.event = unloadEvent;
            //iframe.contentWindow.event.clientY = -1;
            try {
                // allow cancel close
                // iframe.contentWindow.onbeforeunload.call(iframe.contentWindow, iframe.contentWindow.event);
                this.iframe.contentWindow.dispatchEvent(unloadEvent);
                //abort 
                if (unloadStopped)
                    return false;
                else if (typeof unloadEvent.returnValue === 'string') { // IE ask
                    if (!window.confirm(unloadEvent.returnValue))
                        return false;
                }
                else if (unloadEvent.returnValue === false)// && !window.confirm("you may have unsaved data, do you still want to close?"))
                    return false;
            } catch (e) {
                console.log('execute beforeunload ' + e);
            }
            //   iframe.contentWindow.event = new Event('unload');
            //   iframe.contentWindow.event.clientY = -1;
            try {
                //     iframe.contentWindow.onunload.call(iframe.contentWindow, iframe.contentWindow.event);
                this.iframe.contentWindow.dispatchEvent(new Event('unload'));
            } catch (e) {
                console.log('execute unload ' + e);
            }
            this.closed = true;
        }
        if (this.urlConfig.needReload && bAutoRemove) {
            // kill too early return Dailog return is gone 
            Frame.RemoveFrame(this);
        }
        return this.closed;
    }

    restart(newurl: string | null = null) {
        // just show what was left, it is good for mainlist, calendar, no restart
        // some select 3rd party dialog
        // most of page need restart
        // TODO: some times rerun onload is not enough
        // some old code init code is global, need to re-set page script which may have
        // code fixes, like , id changes from url if pattern is allowed
        // restart page by rerun onload  it will work for most of popup edit html code, which just need re 
        // init livedataRoot from parent
        if (this.closed && this.urlConfig.needRestart === true) {
            if (this.urlConfig.restartFunc) {
                this.urlConfig.restartFunc.call(this.iframe.contentWindow, newurl, this.url, this.iframe.contentWindow);
            } else if (this.urlConfig.needCompatHost) {
                // loader's onload is too much, it rebuild whole page again, we need to call onload function for the real body which is onload_f_1()
                for (let i = 1; i < 10; i++) {
                    // but is these function actually works?
                    if (this.iframe.contentWindow && (typeof this.iframe.contentWindow['onload_f_' + i] === 'function'))
                        this.iframe.contentWindow['onload_f_' + i].call(this.iframe.contentWindow);
                }
            } else if (this.iframe.contentWindow && (typeof this.iframe.contentWindow.onload === 'function'))
                this.iframe.contentWindow.onload.call(this.iframe.contentWindow);
        }
        this.url = newurl;
        this.closed = false;
    }
}
class FrameManager {
    mainHolder: HTMLElement;
    mainHistory: Array<Frame> = [];
    mainHistoryCurrPos = 0;
    constructor(mainHolder: HTMLElement) {
        this.mainHolder = mainHolder;
    }
    updateHolder(mainHolder: HTMLElement) {
        this.mainHolder = mainHolder;
    }
    get currentFrame(): Frame {
        return this.mainHistory[this.mainHistoryCurrPos - 1];
    }
    navigate(url: string, winObjs?: any) {
        let frame: Frame | undefined = Frame.GetFrame(url, this.mainHolder);
        if ((!this.currentFrame || this.currentFrame.close())) {  //if same url, user want to refresh
            // close do not hide it 
            if (this.currentFrame)
                this.currentFrame.hideFrame();
            if (frame) {
                frame.showFrame();
                //TODO:remove added window objects after close
                if (typeof winObjs === 'object') {
                    let frameContentWindow = frame.iframe.contentWindow;
                    if (frameContentWindow) {
                        const objKeys = Object.keys(winObjs)
                        for (let p = 0; p < objKeys.length; p++) {
                            frameContentWindow[objKeys[p]] = winObjs[objKeys[p]];
                        }
                    }
                }
                frame.restart(url);
            }
            else {
                var This = this;
                frame = new Frame(url, this.mainHolder, Object.assign({
                    navigateNewPage: function (url: string | 1 | -1) {
                        if (typeof url === 'string')
                            This.navigate(url);
                        else if (url === -1)
                            This.goBack();
                        else if (url === 1)
                            This.goForward();
                    }
                }, winObjs));
            }
            this.mainHistory.splice(this.mainHistoryCurrPos);
            this.mainHistory.push(frame);
            this.mainHistoryCurrPos++;
        }
        return frame;
    }
    goBack() {
        if (this.mainHistoryCurrPos > 0) {
            var currFrm = this.currentFrame;
            if (currFrm.close()) {
                currFrm.hideFrame();
                this.mainHistoryCurrPos--;
                this.currentFrame.restart();
                this.currentFrame.showFrame();
            }
        }
    }
    goForward() {
        if ((this.mainHistoryCurrPos - 1) < this.mainHistory.length) {
            var currFrm = this.currentFrame;
            if (currFrm.close()) {
                currFrm.hideFrame();
                this.mainHistoryCurrPos++;
                this.currentFrame.restart();
                this.currentFrame.showFrame();
            }
        }
    }
}
interface IEDialogElement extends HTMLDivElement {
    close(): void;
    hide(): void;
    open: boolean;
    show(): void;
    showModal(): void;
    returnValue: any;

}

class Dialog extends FrameManager {
    mainHolder: IEDialogElement = null;  //overwrite default type, has additional properties 
    launcherFrame: Frame; // only should be has something when it is active
    closeCallback: (isCancel: boolean) => void;
    openModal: boolean;
    close(isCancel = false): boolean {
        var ret = true;
        if (!this.currentFrame.closed) {
            ret = this.currentFrame.close(false);

            if (ret) {
                if (this.launcherFrame)
                    this.launcherFrame.currentPopup = undefined;
                if (this.closeCallback) {
                    this.closeCallback.call(this, isCancel);
                }
            }
        }
        // close dialog
        if (ret) {// it is OK to use close, keep in the dom! (cannot close, it will remove dialog from holder )
            if (this.launcherFrame)
                this.launcherFrame.currentPopup = undefined;
            this.mainHolder.close();
        }
        return ret;
    }
    constructor() {
        // add to the DOM before add iframe
        var dialog = window.document.body.appendChild(window.document.createElement('dialog'));
        dialog.innerHTML = '<div style="height:40px;"><i id="dialog-close" class="fa-light fa-xmark overlay-close"></i></div>';
        super(dialog);
        //  dialogPolyfill.registerDialog(dialog);
        var closeBtn = dialog.firstElementChild?.firstElementChild;
        var This = this;
        closeBtn?.addEventListener('click', function (ev: Event) {
            ev.preventDefault();
            ev.cancelBubble = true;
            This.close();
        });
        dialog.addEventListener('close', function () {
            // this no UI to close, have to be a code to close it, so we already closed, no need to call close should already closed
            // is there a key to close modeldialog in browser??
            let onCloseEvent = This.currentFrame.urlConfig.onCloseEvent;
            if (onCloseEvent > "") {
                let urlMatch = This.currentFrame.urlConfig.onCloseEventURLMatch;
                let onCloseFire = true;
                if (urlMatch > "") {
                    let url = This.currentFrame.url.toLowerCase();
                    if (url.indexOf(urlMatch.toLowerCase()) === -1) {
                        onCloseFire = false;
                    }
                }
                if (onCloseFire) {
                    switch (onCloseEvent) {
                        case "loadEditLawyer":
                            let solicitor = structuredClone(SolicitorNavigate);
                            let curURL = This.currentFrame?.parentDialog?.launcherFrame?.url;
                            let currentID = curURL?.match(/&id=(.*?)&/)
                            if (currentID.length > 1) {
                                solicitor.params.id = currentID[1];
                            }
                            let currFrame: any = This.currentFrame?.parentDialog?.launcherFrame.iframe.contentWindow;
                            currFrame.liveformSetDirty();
                            //reactNavigation.current(solicitor, state?.SessionID); 
                            const event = new CustomEvent("LDDChangeFrame", { detail: solicitor })
                            dispatchEvent(event);
                            break;
                    }
                }
            }
            console.assert(This.currentFrame.closed);
            // ev.preventDefault();
            // This.close();
        });
        dialog.addEventListener('cancel', function (ev: Event) {
            // Can I stop it?, ESC key??
            ev.preventDefault();
            This.close(true);
        });
        let holderBuilder: any = dialog;
        holderBuilder.hide = function () { return null };
        holderBuilder.align = ""
        this.mainHolder = holderBuilder;
        // $(dialog).resizable();
    }

    showDialog(isModal: boolean, newurl: string, arg: any, dialogStyle: string, launcher?: Frame): Promise<any> | Window | null {
        // if lfpopup.asp?formsrc= xml, load it directly to dialog instead of iframe?
        //<iframe id="dialog-body" src = "' + url + '" style = "border:0; width:100%;height:94%;" > </iframe>
        var dialog: IEDialogElement = this.mainHolder;
        //TODO: change size of dialog
        if (dialogStyle !== 'inframe') {
            dialog.setAttribute('style', dialogStyle + (dialogStyle[dialogStyle.length - 1] !== ";" ? ";" : "") + "resize:auto; overflow:hidden;");
            if (isModal) {
                dialog.classList.add('overlay');
            }
        }
        var This = this;
        var modalArg = {
            '_isLDDDialog': true,
            close: () => This.close(), // overwrite close function for iframe window
        }
        //     if (Object.keys(arg).length > 0){
        modalArg["dialogArguments"] = arg;
        modalArg["returnValue"] = null;
        modalArg['compat_addPleaseWait'] = function (msg: string) {
            if (dialog?.firstElementChild?.firstElementChild) {
                dialog.firstElementChild.insertAdjacentHTML('afterbegin', "<div class='loading-container' style='position: absolute;'><div class='loading-bg' style='opacity:0.6; position: absolute;'></div><div class='loading-content'><i class='fa-duotone fa-spinner fa-5x fa-spin'></i><span><p><b>" + msg + "</b></p></span></div></div>");
            }
        }
        modalArg['compat_deletePleaseWait'] = function () {
            if (dialog?.firstElementChild?.firstElementChild) {
                dialog.firstElementChild.removeChild(dialog.firstElementChild.firstElementChild);
            }
        }
        ///      }
        if (this.navigate(newurl, modalArg)) {
            // iframe created
            this.launcherFrame = launcher;
            if (launcher) {
                launcher.currentPopup = this;
            }
            this.currentFrame.parentDialog = this;
            var iframe = this.currentFrame.iframe;
            // 
            iframe.id = "dialog-body";
            iframe.setAttribute('style', "border:0; width:100%;height:calc(100% - 40px);");
            // loader need to know is it is dialog window
            // overload close function inside dialog iframe
            // already open once before, just hidden
            if (dialog.open) {
                // both have to be same type of window modal or modeless
                console.assert(isModal === this.openModal, `dialog for ${newurl} already in different mode`);
                this.mainHolder.hidden = false;
            } else {
                if (isModal) {
                    this.openModal = true;
                    this.mainHolder.showModal();
                }
                else {
                    this.openModal = false;
                    this.mainHolder.show();
                }
            }
            if (isModal) {
                return new Promise(function (resolve, reject) {
                    This.closeCallback = function (isCancel: boolean) {
                        if (isCancel)
                            reject();
                        else {
                            resolve(iframe.contentWindow ? iframe.contentWindow['returnValue'] : null);
                        }
                        // window can be closed after resolve is run
                        if (This.currentFrame.urlConfig.needReload) {
                            Frame.RemoveFrame(This.currentFrame);
                        }
                    };
                });
            } else
                return this.currentFrame.iframe.contentWindow;
        } else {
            if (isModal)
                return Promise.reject('fail to close current dialog');
            else
                return null;
        }
    }
}
/***
 * looks like a section of liveform in a liveform frame, but it is seperate iframe
 * it make some old popup edit screen looks like inplace editing but still keep the 
 * seperate iframe code base to handle proper global nodes like livedataRoot etc.
 * this dialog belong to the launcher frame logicially, so when the launcher frame close it will close with it.
 * 
 */
export class InframeDialog extends Dialog {
    constructor(launcherFrame: Frame) {
        super();
        // modify mainholder 
        var dialog = launcherFrame.iframe.parentElement.appendChild(window.document.createElement('div'));
        dialog.className = 'FileHight';
        dialog.setAttribute('style', 'height:100%');
        let holderBuilder: any = dialog;
        // support all dialog functions and properties
        // holderBuilder.returnValue = 
        holderBuilder.open = false;
        holderBuilder.close = function () {
            this.style.display = 'none';
            this.open = false;
            launcherFrame.showFrame();
            //    return true;  // this.returnValue;;
        };
        holderBuilder.show = function () {
            launcherFrame.hideFrame();
            this.style.display = '';
            this.open = true;
        };
        holderBuilder.showModal = function () {
            launcherFrame.hideFrame();
            this.style.display = '';
            this.open = true;
        };
        holderBuilder.hide = function () {
            this.style.display = 'none';
            this.open = false;
            return null;
        };
        holderBuilder.align = "";
        this.updateHolder(holderBuilder);
    }
}

function showDialog(isModal: boolean, url: string, args: any, opt: string, launcher?: Frame): Promise<any> | Window | null {
    var f = Frame.GetFrame(url, 'dialog');
    var dialog: Dialog;
    console.assert(opt !== 'inframe' || launcher, 'open inframe dialog with no active frame');
    if (f) {
        if (f.parentDialog) {
            dialog = f.parentDialog;
        }
        else {
            console.log(`url '${url}' cached but it is not a Dialog, create dialog for it`);
        }
    }
    if (!dialog) {
        if (opt === 'inframe') {
            if (typeof launcher === "object") {
                dialog = new InframeDialog(launcher);
            } else {
                dialog = new Dialog();
            }
        } else {
            dialog = new Dialog();
        }
    }
    return dialog.showDialog(isModal, url, args, opt, launcher);
}
// modal return a promise
export function showModalDialog(url: string, args: any, opt: string, launcher: Frame) {
    //TODO: move this check to search urlConfig obj 
    // to support InframeDialog, react components as dialogbox, or just in frame div 
    if (url.match(/private\/defect(Adj)?[Aa]sks/) && url.indexOf("inframe=no") === -1) {
        // issuescreen
        //    return NewOrCoptToInbox()
        return showDialog(true, url, args, 'inframe', launcher);
    }
    return showDialog(true, url, args, opt, launcher);
}
// return window iframe object before dialog close
export function showModelessDialog(url: string, args: any, opt: string, launcher?: Frame) {
    return showDialog(false, url, args, opt, launcher);
}

// function navObjToString(navigation: NavObjectType, sid: string): string | 1 | -1 {
//     let url: string | 1 | -1 = navigation.url;
//     if (typeof url === "string") {
//         const params = new URLSearchParams(navigation.params)
//         if (params && Array.from(params).length) {
//             url = url + (url.indexOf("?") === -1 ? "?" : "&") + params.toString()
//         }
//         if (url.indexOf("SessionID=") === -1) {
//             url = url + (url.indexOf("?") === -1 ? "?" : "&") + "SessionID=" + sid
//         }
//     }
//     return url
// }

export function navigateNewPage(url: string | -1 | 1, winObjs?: any): any {
    if (mainFrameManager) {
        if (typeof url === 'string') {
            try {
                if (url.indexOf("purfileedit") !== -1) {
                    if (url.indexOf("ReactDocument") === -1) {
                        url = url + "&ReactDocument=1";
                    }
                }
                mainFrameManager.navigate(url, winObjs);
                // Navigation for purfile edit
                /*if (navControlParams) {

                    // Skip reloading page if nav is from 
                    const urlParam: string = url;
                    const navigatePage = new Promise((resolve, reject) => {
                        let passingObjects = {
                            ...winObjs,
                            'ShellInitFunc': (window) => {resolve(window)}
                        }
                        mainFrameManager.navigate(urlParam, passingObjects);
                    })
                    return navigatePage
                } else {
                }
                /*
                if (navControlParams) {
                    /*
                    let window = mainFrameManager?.currentFrame?.iframe?.contentWindow
                    if (window) {
                        window['shellTabName'] = navControlParams.tabName;
                        window['shellTabNumber'] = navControlParams.tabNumber;
                        window['ShellInitFunc'] = ((window, tabName, tabNumber) => {
                            const controller = new ScreenController(window);
                            try {
                                controller.setTabFromName(tabName, tabNumber)
                            } catch (e) {
                                console.log("Cannot currently setTab, ensure file is loaded")
                            }
                        })
                        if (navControlParams.refresh) {
                            mainFrameManager.navigate(url, winObjs);
                        } else {
                            const controller = new ScreenController(window);
                            controller.setTabFromName(navControlParams.tabName, navControlParams.tabNumber)
                        }
                    } else {
                        mainFrameManager.navigate(url, winObjs);
                        window = mainFrameManager?.currentFrame?.iframe?.contentWindow;
                        window['shellTabName'] = navControlParams.tabName;
                        window['shellTabNumber'] = navControlParams.tabNumber;
                        window['ShellInitFunc'] = ((window, tabName, tabNumber) => {
                            const controller = new ScreenController(window);
                            controller.setTabFromName(tabName, tabNumber)
                        })
                    }
                } else {
                    mainFrameManager.navigate(url, winObjs);
                }
                */
            } catch (e) {
                console.log(e);
            }
        }
        else if (url === -1)
            mainFrameManager.goBack();
        else if (url === 1)
            mainFrameManager.goForward();
    }
}
function dialogSizeParse(opt) {
    var ret = null;
    if (opt > "") {
        opt = opt.toLowerCase();
        ret = opt.replace(/(dialog)(\w+)(\=|\:)/g, '$2:');
    }
    return ret;
}
export function navigatePopupPage(url: string, popupStyle = "xlarge", isModal = false, args: any = null) {
    // if(url.indexOf("SetVIPMsgAction") !== -1) {
    //     return new Promise((resolve) => {
    //         // return <ImportFileList resolve={resolve} />;
    //     })
    // }
    //var item = contentWindow.liveformGetItemXMLNode(item)
    let dialogStyle = "";
    if (popupStyle === "small") dialogStyle = "dialogHeight=400px;dialogWidth=460px";
    else if (popupStyle === "medium") dialogStyle = "dialogHeight=550px;dialogWidth=640px";
    else if (popupStyle === "large") dialogStyle = "dialogHeight=550px;dialogWidth=820px";
    else if (popupStyle === "xlarge") dialogStyle = "dialogHeight=700px;dialogWidth=1140px";
    else if (popupStyle === "xlargelong") dialogStyle = "dialogHeight=950px;dialogWidth=1200px";
    else if (popupStyle === "settings") dialogStyle = "dialogHeight=700px;dialogWidth=1040px";
    else if (popupStyle === "hidden") dialogStyle = "dialogHeight=0px;dialogWidth=0px";
    else if (!(dialogStyle > "")) dialogStyle = "dialogHeight=550px;dialogWidth=800px";
    dialogStyle = dialogSizeParse(dialogStyle);
    if (args && args.livedataRoot && !args.liveformPopupDataNode) {
        args.liveformPopupDataNode = args.livedataRoot;
    }

    var retVal = null;
    if (isModal) {
        retVal = showModalDialog(url, args, dialogStyle, mainFrameManager.currentFrame);
    } else {
        retVal = showModelessDialog(url, args, dialogStyle, mainFrameManager.currentFrame);
    }

    //		liveformSetDirty(item);
    return retVal;
}

export function getCurrentDataRoot() {
    let currentWindow: any = mainFrameManager?.currentFrame?.iframe?.contentWindow;
    return currentWindow?.livedataRoot
}

// close all non active frame, before window exit. so it will not execute  unload code
export function cleanUpClosed() {
    // keep only active Frames include dialog 
    FrameCache = FrameCache.filter((frame) => {
        if (frame.closed) {
            if (frame.parentDialog && frame.parentDialog.mainHolder && frame.parentDialog.mainHolder.parentElement)
                frame.parentDialog.mainHolder.parentElement.removeChild(frame.parentDialog.mainHolder);
            else if (frame && frame.iframe && frame.iframe.parentElement)
                frame.iframe.parentElement.removeChild(frame.iframe);
        }
        return !frame.closed;
    });
}

export function closeAll(): boolean {
    const closed = FrameCache.map((frame) => frame.close());
    const ret = closed.reduce((x, y) => x && y, true);
    return ret;
}
var mainFrameManager: FrameManager;
var mainHostServiceObjs: any = {};
// let reactNavigation: { current: (nav: NavObjectType) => void } = { current: () => console.log("navigation function not loaded") };
export function init(hostdiv: HTMLElement, config?: { compatConfig?: SiteConfig, serviceObjs?: any }, navigationFunction?) {
    // load site config, if exist inside siteconfig.js
    if (typeof config.compatConfig === 'object') {
        siteConfig = config.compatConfig;
    }
    if (config.serviceObjs)
        mainHostServiceObjs = config.serviceObjs;
    mainFrameManager = new FrameManager(hostdiv);
    if (navigationFunction) {
        // reactNavigation = navigationFunction;
    }
}

export function updateHost(hostdiv: HTMLElement) {
    mainFrameManager.mainHolder = hostdiv
}

export function addCalendarAppointment() {
    let currentWindow: any = mainFrameManager?.currentFrame?.iframe?.contentWindow;
    currentWindow.AddNewAppointment();
}

export function getCurrentContentWindow() {
    let currentWindow: any = mainFrameManager?.currentFrame?.iframe?.contentWindow;
    return currentWindow;
}
/**
 * Close active Components related to CurrentFrame
 * @returns true if closed (continue to do whatever),  false should stop
 */
export function CloseInframeComponent(): boolean {
    let currentFrame: Frame = mainFrameManager?.currentFrame;
    if (currentFrame) {
        return currentFrame.closePopup();
    } else {
        return true;
    }
}
type Primitive = string | number | boolean | null | object;
type BasicArray = Array<BasicType>;
// @ts-expect-error Intentionally allowing circular reference
type BasicObject = Record<number | string, BasicType>;
// @ts-expect-error Intentionally allowing circular reference
type BasicType = Primitive | BasicArray | BasicObject;
export function runInnerFunction(functionName: string, params: BasicType, window?: any): any {
    const stringParams = (params === null) ? null : JSON.stringify(params);
    let innerWindow: any = window ? window : mainFrameManager?.currentFrame?.iframe?.contentWindow;
    if (innerWindow) {
        //let retval = innerWindow.eval(`${functionName}(${stringParams})`);
        let retval = innerWindow.runInternalFunction(functionName, stringParams)
        return retval;
    } else {
        throw ""
    }
}

/**
 * runInnterFunction but takes in multiple parameters
 * @param functionName 
 * @param params Array of params
 * @param window 
 * @returns 
 */
export function runInnerFunction2(functionName: string, params: BasicArray, window?: any): any {
    params = params.map(item => `'${item}'`);
    const stringParams = params.join(", ");
    let innerWindow: any = window ? window : mainFrameManager?.currentFrame?.iframe?.contentWindow;
    if (innerWindow) {
        let retval = innerWindow.eval(`${functionName}(${stringParams})`);
        return retval;
    } else {
        throw ""
    }
}

export function setInnerDataNode(dataNode: any, window?: any): any {
    let innerWindow: any = window ? window : mainFrameManager?.currentFrame?.iframe?.contentWindow;
    if (innerWindow) {
        const location = {test: ""};
        innerWindow = {...innerWindow, dialogArguments: {liveformPopupDataNode: dataNode, location: location, test: "test"}};
    } else {
        throw ""
    }
}